// infoStruct.ts

import { isDeviceMobile } from '@utils/mobile'

import type { InfoStruct } from './store'
const base = import.meta.env.BASE_URL
const isMobile = isDeviceMobile()

export const infoStruct: InfoStruct = {
	contact: [
		{
			id: 1,
			value: '1',
			label: 'Fotografa o allega i documenti',
			type: 'contact',
			imageDesk: `${base}images/ico_fotografa.png`,
			imageMob: `${base}images/xs_ico_fotografa.png`,
			subSteps: [
				{
					id: 0,
					value: 'contactData', //chiave per il render su wizard
					type: 'dialog', //tipo di oggetto e azione definita
					label: 'Fotografa e allega',
					completed: false,
					required: true,
				},
				{
					id: 1,
					value: '1',
					label: "Documento d'identità",
					completed: false,
					required: true,
					documents: [
						{ id: 1, key: 'selectDocument', label: 'Seleziona documento' },
						{ id: 2, key: 'uploadDoc', label: 'Carica documento' },
						{ id: 3, key: 'uploadSuccess', label: 'Completato' },
					],
				},
				{
					id: 2,
					value: '2',
					label: 'Codice fiscale',
					completed: false,
					required: true,
					documents: [
						/*  serve per i documenti */
					],
				},
				{
					id: 3,
					value: '3',
					label: 'Documento di reddito',
					completed: false,
					required: false,
					documents: [
						/*serve per i documenti */
					],
				},
			],
		},
		{
			id: 2,
			value: '2',
			label: `${isMobile ? 'Fotografa o allega i documenti' : 'Allega i documenti'}`,
			type: 'contact',
			imageDesk: `${base}images/ico_allega.png`,
			imageMob: isMobile
				? `${base}images/xs_ico_fotografa.png`
				: `${base}images/xs_ico_allega_alt.png`,
			subSteps: [
				{
					id: 1,
					value: '1',
					label: "Documento d'identità",
					completed: false,
					required: true,
					documents: [
						{ id: 1, key: 'selectDocument', label: 'Seleziona documento' },
						{ id: 2, key: 'uploadDoc', label: 'Carica documento' },
						{ id: 3, key: 'uploadSuccess', label: 'Completato' },
					],
				},
				{
					id: 2,
					value: '2',
					label: 'Codice fiscale',
					completed: false,
					required: true,
					documents: [
						/*  serve per i documenti */
					],
				},
				{
					id: 3,
					value: '3',
					label: 'Documento di reddito',
					completed: false,
					required: false,
					documents: [
						/*serve per i documenti */
					],
				},
			],
		},
		{
			id: 3,
			value: '3',
			label: 'Inserisci i dati manualmente',
			type: 'contact',
			imageDesk: `${base}images/ico_ins_manualmente.png`,
			imageMob: `${base}images/xs_ico_ins_manualmente.png`,
			subSteps: [
				{
					id: 1,
					value: 'contactData', //chiave per il render su wizard
					type: 'form', //tipo di oggetto e azione definita
					label: 'Dati di contatto',
					completed: false,
					required: true,
				},
			],
		},
	],

	data: [
		// option list radio
		{
			cittadinanza: [
				{
					id: 1,
					value: 'EU',
					label: 'Comunitaria',
					imageDesk: '',
					imageMob: '',
				},
				{
					id: 2,
					value: 'EX',
					label: 'Extra Unione Europea',
					imageDesk: '',
					imageMob: '',
				},
				{ id: 3, value: 'IT', label: 'Italiana', imageDesk: '', imageMob: '' },
			],
		},
		{
			CitizenshipType: [
				{
					id: 1,
					value: 'PSG',
					label: 'Determinato',
					imageDesk: '',
					imageMob: '',
				},
				{
					id: 2,
					value: 'PSL',
					label: 'Lungo termine (DM 2021)',
					imageDesk: '',
					imageMob: '',
				},
				{
					id: 3,
					value: 'PSI',
					label: 'Indeterminato',
					imageDesk: '',
					imageMob: '',
				},
			],
		},

		{
			statocivile: [
				{ id: 1, value: 'A', label: 'Convivente', imageDesk: '', imageMob: '' },
				{
					id: 2,
					value: 'C',
					label: 'Celibe/Nubile',
					imageDesk: '',
					imageMob: '',
				},
				{
					id: 3,
					value: 'D',
					label: 'Divorziato/a',
					imageDesk: '',
					imageMob: '',
				},
				{
					id: 4,
					value: 'G',
					label: 'Coniugato/a',
					imageDesk: '',
					imageMob: '',
				},
				{ id: 5, value: 'S', label: 'Separato/a', imageDesk: '', imageMob: '' },
				{ id: 6, value: 'V', label: 'Vedovo/a', imageDesk: '', imageMob: '' },
			],
		},
		{
			tipoabitazione: [
				{
					id: 1,
					value: 'P',
					label: 'Proprietà',
					imageDesk: '',
					imageMob: '',
				},
				{ id: 2, value: 'A', label: 'Affitto', imageDesk: '', imageMob: '' },
				{ id: 3, value: 'G', label: 'Parenti', imageDesk: '', imageMob: '' },
				{ id: 4, value: 'T', label: 'Terzi', imageDesk: '', imageMob: '' },
				{
					id: 5,
					value: 'D',
					label: 'Datore lavoro',
					imageDesk: '',
					imageMob: '',
				},
				{ id: 6, value: 'X', label: 'Altro', imageDesk: '', imageMob: '' },
			],
		},
		{
			tipodocumento: [
				{
					id: 1,
					value: 'IDE',
					label: "Documento d'identità",
					imageDesk: '',
					imageMob: '',
				},
				{ id: 2, value: 'PAT', label: 'Patente', imageDesk: '', imageMob: '' },
			],
		},
		{
			recuperadati: [
				{
					id: 1,
					value: 'OTP',
					label: 'Genera OTP',
					imageDesk: '',
					imageMob: '',
				},
				{
					id: 2,
					value: 'NOOTP',
					label: 'Inserisci Manualmente',
					imageDesk: '',
					imageMob: '',
				},
			],
		},
		// CONFIG NAVIGAZIONE LINEARE
		{
			anagraficaSubSteps: [
				// STEP 1
				{
					id: 1,
					key: 'citizenshipCivil',
					label: 'Cittadinanza e Stato civile',

					type: 'radio-group',

					rhfFields: ['anagrafica.cittadinanza', 'anagrafica.statocivile'],
				},

				// STEP 2
				{
					id: 2,
					key: 'abitazione',
					label: 'Abitazione',

					type: 'radio+inputs',

					rhfFields: [
						'anagrafica.tipoAbitazione',
						'anagrafica.indirizzoResidenza',
						'anagrafica.cap',
					],

					conditional: [
						{
							whenValueIs: 'AFF',
							requiredFields: ['anagrafica.importoAffitto'],
						},
					],

					clearOnChange: ['anagrafica.importoAffitto'],
				},

				// STEP 3
				{
					id: 3,
					key: 'documento',
					label: 'Documento identità',

					type: 'radio+inputs',

					rhfFields: [
						'anagrafica.tipoDocumento',
						'anagrafica.numeroDocumento',
						'anagrafica.provinciaRilascio',
						'anagrafica.dataRilascio',
					],
				},
			],
		},
	],

	profession: [
		// ── Attività options ────────────────────────────────────────────────────
		{
			attivita: [
				{
					id: 1,
					value: 'D',
					label: 'Dipendente a tempo indeterminato',
					imageDesk: '',
					imageMob: '',
				},
				{
					id: 2,
					value: 'T',
					label: 'Dipendente a tempo determinato',
					imageDesk: '',
					imageMob: '',
				},
				{
					id: 3,
					value: 'P',
					label: 'Pensionato/a',
					imageDesk: '',
					imageMob: '',
				},
				{ id: 4, value: 'A', label: 'Autonomo', imageDesk: '', imageMob: '' },
				{ id: 5, value: 'X', label: 'Altro', imageDesk: '', imageMob: '' },
			],
		},
		// ── Occupazione options keyed by Activity value ─────────────────────────
		{
			occupazionePerAttivita: {
				// Autonomo — shows company form below + full reddito substep
				A: [
					{
						id: 1,
						value: 'NE',
						label: 'Negoziante',
						imageDesk: '',
						imageMob: '',
					},
					{
						id: 2,
						value: 'PR',
						label: 'Professionista',
						imageDesk: '',
						imageMob: '',
					},
					{
						id: 3,
						value: 'TA',
						label: 'Titolare azienda',
						imageDesk: '',
						imageMob: '',
					},
				],
				// Dipendente a tempo indeterminato — shows company form below + full reddito substep
				D: [
					{
						id: 1,
						value: 'IM',
						label: 'Impiegato',
						imageDesk: '',
						imageMob: '',
					},
					{
						id: 2,
						value: 'IQ',
						label: 'Quadro/Dirigente',
						imageDesk: '',
						imageMob: '',
					},
					{ id: 3, value: 'OP', label: 'Operaio', imageDesk: '', imageMob: '' },
				],
				// Dipendente a tempo determinato — shows company form below + full reddito substep
				T: [
					{
						id: 1,
						value: 'IM',
						label: 'Impiegato',
						imageDesk: '',
						imageMob: '',
					},
					{
						id: 2,
						value: 'IQ',
						label: 'Quadro/Dirigente',
						imageDesk: '',
						imageMob: '',
					},
					{ id: 3, value: 'OP', label: 'Operaio', imageDesk: '', imageMob: '' },
				],
				// Pensionato — no company form, full reddito substep
				P: [
					{
						id: 1,
						value: 'PE',
						label: 'Pensionato',
						imageDesk: '',
						imageMob: '',
					},
					{
						id: 2,
						value: 'IV',
						label: 'Invalido civile',
						imageDesk: '',
						imageMob: '',
					},
				],
				// Altro — Studente: no form + IBAN only substep; Altro: no form + full reddito substep
				X: [
				/* 	{
						id: 1,
						value: 'ST',
						label: 'Studente',
						imageDesk: '',
						imageMob: '',
					}, */
					{ id: 2, value: 'AL', label: 'Altro', imageDesk: '', imageMob: '' },
				],
			},
		},
		// ── Settore attività — used in the company-details form (SubStep0) ────────
		{
			settoreAttivita: [
				{ code: 'PRI', label: 'Privato' },
				{ code: 'PUB', label: 'Pubblico' },
				{ code: 'PRE', label: 'Previdenziale' },
				/* { code: 'COL', label: 'Commercio al dettaglio' },
				{ code: 'CIN', label: 'Commercio all\'ingrosso' },
				{ code: 'COS', label: 'Costruzioni ed edilizia' },
				{ code: 'EDU', label: 'Istruzione e formazione' },
				{ code: 'FIN', label: 'Finanza e assicurazioni' },
				{ code: 'ICT', label: 'Informatica e tecnologia' },
				{ code: 'IND', label: 'Industria manifatturiera' },
				{ code: 'MED', label: 'Sanità e assistenza' },
				{ code: 'RIS', label: 'Ristorazione e turismo' },
				{ code: 'TRA', label: 'Trasporti e logistica' },
				{ code: 'SER', label: 'Servizi professionali' },
				{ code: 'ALT', label: 'Altro' }, */
			],
		},
		// ── Tipo contratto — D (indeterminato) ────────────────────────────────────
		{
			tipoContratto: [
				{ code: 'F', label: 'Full-time' },
				{ code: 'P', label: 'Part-time' },
			],
		},
		// ── Tipo contratto — T (determinato) ────────────────────────────────────
		{
			tipoContrattoDeterminato: [
				{ code: 'J', label: 'Full-time' },
				{ code: 'K', label: 'Part-time' },
			],
		},

		{
			tipoContrattoPensione: [
				{ code: 'R', label: 'Pensione da lavoro' },
				{ code: 'M', label: 'Pensione Minima' },
			],
		},
		// ── Mensilità — used in the reddito substep (SubStep1) ───────────────────
		{
			mensilita: [
				{ id: 1, value: '12', label: '12', imageDesk: '', imageMob: '' },
				{ id: 2, value: '13', label: '13', imageDesk: '', imageMob: '' },
				{ id: 3, value: '14', label: '14', imageDesk: '', imageMob: '' },
			],
		},
		// ── PEP — used in the PEP substep (SubStep2) ──────────────────────────────
		{
			pep: [
				{
					id: 1,
					value: 'false',
					label: 'No, non lo sono',
					imageDesk: '',
					imageMob: '',
				},
				{
					id: 2,
					value: 'true',
					label: 'Sì, lo sono',
					imageDesk: '',
					imageMob: '',
				},
			],
		},
	],
	// Services substep config — mirrors the pattern used in contact/data steps.
	// The main view (selectedSubStep === null) shows the insurance questionnaire.
	// SubSteps define the flow AFTER the questionnaire, just like ContactType's
	// radio selection is the main view and its subSteps come after.
	services: [
		{
			id: 1,
			value: 'insurance', // auto-selected when insurance is active
			label: 'Polizza assicurativa',
			type: 'contact',
			imageDesk: '',
			imageMob: '',
			subSteps: [
				{
					id: 1,
					value: 'beneficiaryStep', // first substep after the questionnaire
					type: 'form',
					label: 'Prossimo passo',
					completed: false,
					required: false,
				},
				{
					id: 2,
					value: 'thirdPartyStep', // second substep after the questionnaire
					type: 'form',
					label: 'Prossimo passo',
					completed: false,
					required: false,
				},
				{
					id: 3,
					value: 'identinetStep', // third substep after the questionnaire
					type: 'form',
					label: 'Prossimo passo',
					completed: false,
					required: false,
				},
			],
		},
	],
	summary: [],
}
